import type {
  AvailableFilter,
  ReportDashboardComponentKind,
  ReportDashboardMetricOptions,
} from '@core/reports-types';

import { getComponentDatePoint } from './get-component-date-point';

export const getAvailableFilters = (
  component: { kind: ReportDashboardComponentKind; endPoint?: string | null },
  metric: ReportDashboardMetricOptions,
): AvailableFilter[] => {
  const datePoint = getComponentDatePoint(component, metric, 'startPoint');
  return [...metric.availableFilters, ...(datePoint?.availableFilters ?? [])];
};
